export default __webpack_public_path__ + "c187fdc6ec6c62b3b5be94ab704406b5.png";